"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClickRel = void 0;
const cash_dom_1 = __importDefault(require("cash-dom"));
class ClickRel {
    constructor(elements) {
        this.elements = null;
        if (!elements) {
            return;
        }
        (0, cash_dom_1.default)(elements).each((i, e) => {
            const target = (0, cash_dom_1.default)(e).attr('data-target');
            if (target) {
                (0, cash_dom_1.default)(e).css({ cursor: 'pointer' });
                (0, cash_dom_1.default)(e).on('click', () => {
                    window.open(target, '_self');
                });
                const overlay = (0, cash_dom_1.default)('.overlay', e);
                // console.log(overlay)
                if (overlay) {
                    (0, cash_dom_1.default)(e).css({ cursor: 'pointer' });
                    (0, cash_dom_1.default)(e).on('click', () => {
                        window.open(target, '_self');
                    });
                }
            }
        });
    }
}
exports.ClickRel = ClickRel;
